<template>
    <div class="table">
        <div class="container">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList('search')">
                <el-form-item label="角色名">
                    <el-input v-model="dataForm.nameZh"
                              placeholder="请输入角色名" clearable></el-input>
                </el-form-item>
                <el-form-item label="角色编码">
                    <el-input v-model="dataForm.name"
                              placeholder="请输入角色编码" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList('search')" icon="el-icon-search">查询</el-button>
                    <el-button type="primary" v-if="isAuth('sys-role-add')"
                               @click="addOrUpdateSysUser()">新增
                    </el-button>
                    <el-button type="danger" @click="deleteHandle()"
                               v-if="isAuth('sys-role-delete')"
                               :disabled="dataListSelections.length <= 0">批量删除
                    </el-button>
                </el-form-item>
            </el-form>
            <el-table
                    :data="dataList"
                    border
                    v-loading="dataListLoading"
                    @selection-change="selectionChangeHandle"
                    style="width: 100%;">
                <el-table-column
                        type="selection"
                        header-align="center"
                        align="center"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="id"
                        header-align="center"
                        align="center"
                        width="80"
                        label="编号">
                </el-table-column>
                <el-table-column
                        prop="nameZh"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="角色名">
                </el-table-column>
                <el-table-column
                        prop="name"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="角色编码">
                </el-table-column>
                <el-table-column
                        prop="creationDate"
                        header-align="center"
                        align="center"
                        :show-overflow-tooltip="true"
                        label="创建时间">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        header-align="center"
                        align="center"
                        width="200"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" size="small"
                                   @click="addOrUpdateSysUser(scope.row.id)"
                                   v-if="isAuth('sys-role-edit')">编辑
                        </el-button>
                        <el-button type="danger" icon="el-icon-delete" size="small"
                                   :disabled="scope.row.name==='ROLE_admin'"
                                   v-if="isAuth('sys-role-delete')"
                                   @click="deleteHandle(scope.row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    @size-change="sizeChangeHandle"
                    @current-change="currentChangeHandle"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    :total="totalPage"
                    layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <sys-role-add-or-update v-if="addOrUpdateVisible" ref="sysRole"
                                @getDataList="getDataList()"></sys-role-add-or-update>
    </div>
</template>

<script>
    import {SysRole} from "../../api/sysRole";
    import sysRoleAddOrUpdate from "./sys-role-add-or-update"

    export default {
        name: "sys-role",
        data() {
            return {
                dataForm: {
                    nameZh: '',
                    name: ''
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false
            }
        },
        components: {
            sysRoleAddOrUpdate
        },
        created() {
            this.getDataList();
        },
        activated() {
            this.getDataList();
        },
        methods: {
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            /**
             * 获取数据
             */
            getDataList(type) {
                this.dataListLoading = true;
                if (type === 'search') {
                    this.pageIndex = 1;
                }
                let params = {
                    'nameZh': this.dataForm.nameZh,
                    'name': this.dataForm.name,
                    'pageIndex': this.pageIndex,
                    'limit': this.pageSize
                };
                SysRole.getRoleList(params).then(res => {
                    if (res.code === 0) {
                        this.dataList = res.page.list;
                        this.totalPage = res.page.totalCount;
                    }
                    this.dataListLoading = false;
                });
            },
            /**
             * 添加或修改系统用户
             * @param id
             */
            addOrUpdateSysUser(id) {
                this.addOrUpdateVisible = true;
                this.$nextTick(() => {
                    this.$refs.sysRole.init(id)
                })
            },
            /**
             * 删除
             * @param id
             */
            deleteHandle(id) {
                let ids = id ? id.toString() : this.dataListSelections.map(item => item.id).join();
                //console.log(ids)
                let arrayIds = {'ids': ids};
                this.$confirm('此操作将删除角色信息记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    SysRole.deleteRole(arrayIds).then(res => {
                        if (res.code === 0) {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.$nextTick(() => {
                                        this.getDataList();
                                    })
                                }
                            })
                        }
                    });
                }).catch(() => {
                })
            }
        }
    }
</script>

<style scoped>

</style>
